export const GET_ALL_SOUSCLIENT_REQUEST = "GET_ALL_SOUSCLIENT_REQUEST";
export const GET_ALL_SOUSCLIENT_SUCCESS = "GET_ALL_SOUSCLIENT_SUCCESS";
export const GET_ALL_SOUSCLIENT_FAIL = "GET_ALL_SOUSCLIENT_FAIL";

export const ADD_SOUSCLIENT_REQUEST = "ADD_SOUSCLIENT_REQUEST";
export const ADD_SOUSCLIENT_SUCCESS = "ADD_SOUSCLIENT_SUCCESS";
export const ADD_SOUSCLIENT_FAIL = "ADD_SOUSCLIENT_FAIL";

export const UPDATE_SOUSCLIENT_REQUEST = "UPDATE_SOUSCLIENT_REQUEST";
export const UPDATE_SOUSCLIENT_SUCCESS = "UPDATE_SOUSCLIENT_SUCCESS";
export const UPDATE_SOUSCLIENT_FAIL = "UPDATE_SOUSCLIENT_FAIL";

export const DELETE_SOUSCLIENT_REQUEST = "DELETE_SOUSCLIENT_REQUEST";
export const DELETE_SOUSCLIENT_SUCCESS = "DELETE_SOUSCLIENT_SUCCESS";
export const DELETE_SOUSCLIENT_FAIL = "DELETE_SOUSCLIENT_FAIL";
